export const CONFIG = {
  API_HOST: 'https://sj-avik-backend.reges-services.se',
  FIREBASE_API_KEY: 'AIzaSyAEKP9ESPUuDkBMpEhzWCDi9cMe07AhRys',
  FIREBASE_AUTH_DOMAIN: 'sj-ab-293808.firebaseapp.com',
  TOKEN_NAME: 'sj-avik',
  SENTRY_DSN:
    'https://71a206c8e5fd4b17b40ae62881d99161@o261284.ingest.sentry.io/5842599',
}
